import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SkipPreviousIcon(props: IconProps) {
    return <Icon {...props} iconKey={"skip_previous"}/>
}
